var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{ 'hidden': !_vm.mainUri, 'clickable': _vm.canClick },attrs:{"src":_vm.mainUri},on:{"click":_vm.clicked}})}
var staticRenderFns = []

export { render, staticRenderFns }